import { createGlobalStyle } from "styled-components";
import GothamMedium from "../../fonts/GothamMedium.otf";
import EksellMedium from "../../fonts/EksellDisplayMedium.otf";
export const GlobalStyle = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;

  }

@font-face {
  font-family: 'Gotham';
  src: local('Gotham'), url(${GothamMedium}) format('otf');
  font-weight: 500;
}
@font-face {
  font-family: 'Eksell';
  src: local('Eksell'), url(${EksellMedium}) format('otf');
  letter-spacing: -0.5px;
  font-style: normal;
}
  html,
  body {
    height: 100%;
    width: 100%;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: rgba(17,23,65,1);
    font-size: 14px;
    letter-spacing: 0.5px;
    h1 {
      line-height: 47px;
      color: rgba(17,23,65,1);
      font-size: 40px;
    }
    h2 {
      line-height: 29px;
      color: rgba(132,141,150,1);
      font-size: 25px;
    }
  }
  #root {
    min-height: 100%;
    min-width: 100%;
  }
  p,
  label {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1em;
  }
  input, select {
    font-family: inherit;
    font-size: inherit;
  }
  button:hover{
    cursor: pointer;
  }
  a:hover{
    cursor: pointer;
  }
  .ui.modal>.close{
    color: #000;
    top: 0.5rem;
    right: 0.5rem;
  }
  @media (max-width: 720px) {
    body{
      font-size: 12px;
    }
  }
`;

export const ThemeProps = {
  color: {
    primary: "rgb(0, 101, 242)",
    gabaYellow: "#EEAA35",
    softYellow: "rgba(238, 170, 53, 0.11)",
    white: "#FFFFFF",
    softGray: "#F9F9F9",
    darkBlue: "#111741",
    softPurple: "rgba(114, 128, 219, 0.22)",
    gabaGreen: "#5ab88d",
    darkGreen: "#337859",
    darkGray: "rgb(132, 141, 150)",
  },
  breakpoint: {
    phone: "@include for-size(phone-only)",
    portraitTablet: "@include for-size(tablet-portrait-up)",
    landscapeTablet: "@include for-size(tablet-landscape-up)",
    desktop: "@include for-size(desktop-up)",
    bigDesktop: "@include for-size(big-desktop-up)",
  },
  rules: {
    narrowWidth: "max-width: 1170px;",
  },
};
